/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_BreadcrumbInputs */

const en_control_breadcrumb = /** @type {(inputs: Control_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breadcrumb`)
};

const zh_control_breadcrumb = /** @type {(inputs: Control_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`面包屑导航`)
};

/**
* | output |
* | --- |
* | "Breadcrumb" |
*
* @param {Control_BreadcrumbInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_breadcrumb = /** @type {((inputs?: Control_BreadcrumbInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_BreadcrumbInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_breadcrumb(inputs)
	return zh_control_breadcrumb(inputs)
});
export { control_breadcrumb as "control.breadcrumb" }